import './Expert.scss';

import React from 'react';
// import { Nav } from 'react-bootstrap';
import {
    // Link,
    Outlet, Route, Routes
} from 'react-router-dom';

function ExpertComplete() {
    return (
        <>
            <Outlet />

            <Routes>
                <Route
                    path='1'
                    element={<p>Hello</p>}
                />
                <Route
                    path='2'
                    element={<p>HI</p>}
                />
            </Routes>
        </>
    );
}

export default ExpertComplete;
